import Helper from "@/services/Helper"

export default class Default {
    constructor(shopId) {
        this.shopId = shopId;
    }

    filterParams() {
        let shops = []
        if (this.getShopId()) {
            shops.push(
                this.getShopId()
            )
        }

        return {
            params: {
                search: "",
                search_full_match: true,
                date: null,
                users: [],
                statuses: {
                    published: true,
                    scheduled: true,
                    removed: false,
                    draft: false,
                },
                shops: shops,
                categories: [],
                type_visibility: null,
                type_ids: [],
                is_moderate: null,
                type_id: [],
                promocode: "",
            },
            saveForm: true,
            enable: true,
        }
    }

    prepareQuery(q) {
        let query = Helper.clone(q)

        return query
    }

    getShopId() {
        let queryShopId = this.shopId

        let shopId
        if (!Helper.isEmpty(queryShopId)) {
            shopId = parseInt(queryShopId)
        }

        return shopId
    }
}
